import React from 'react';
function Key({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M2.52151 20.4785L4.52151 18.4785M4.52151 18.4785L7.52151 21.4785L11.0215 17.9785L8.02151 14.9785M4.52151 18.4785L8.02151 14.9785M12.1315 10.8685C12.641 11.3848 13.2476 11.7953 13.9163 12.0762C14.5851 12.3572 15.3028 12.5031 16.0281 12.5055C16.7535 12.5079 17.4722 12.3669 18.1428 12.0904C18.8134 11.8139 19.4227 11.4075 19.9357 10.8946C20.4486 10.3817 20.855 9.77241 21.1314 9.10179C21.4079 8.43117 21.549 7.71249 21.5465 6.98712C21.5441 6.26175 21.3982 5.54403 21.1173 4.87528C20.8363 4.20652 20.4259 3.59995 19.9095 3.09049C18.8722 2.08862 17.4829 1.53425 16.0408 1.54678C14.5987 1.55931 13.2193 2.13774 12.1995 3.15748C11.1798 4.17723 10.6013 5.5567 10.5888 6.99878C10.5763 8.44086 11.1306 9.83017 12.1325 10.8675L12.1315 10.8685ZM12.1315 10.8685L8.02151 14.9785"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Key;
